import { FormField, Input, Select, Textarea } from '@/shared/components';
import { invoiceTaxCategoryOptions, type InvoiceTaxCategory } from '@/shared/api';
import type { PresetFormState } from './presetFormState';

interface Props {
  form: PresetFormState;
  currency: string;
  onChange: (next: PresetFormState) => void;
}

/** Die Felder einer Katalogposition — getrennt vom Dialograhmen, damit beides unter 150 bleibt. */
export function InvoiceItemPresetFields({ form, currency, onChange }: Props) {
  return (
    <>
      <FormField label="Bezeichnung" required hint="So steht sie später auf der Rechnung.">
        <Input
          value={form.label}
          onChange={(event) => onChange({ ...form, label: event.target.value })}
          placeholder="z.B. Parkplatz"
          maxLength={160}
          autoFocus
        />
      </FormField>

      <FormField
        label={`Preis (${currency})`}
        required
        hint="Bruttopreis, je Rechnung überschreibbar."
      >
        <Input
          type="text"
          inputMode="decimal"
          value={form.unitPrice}
          onChange={(event) => onChange({ ...form, unitPrice: event.target.value })}
          placeholder="8,00"
        />
      </FormField>

      <FormField
        label="MwSt-Behandlung"
        required
        hint={
          invoiceTaxCategoryOptions.find((option) => option.value === form.taxCategory)?.hint ?? ''
        }
      >
        <Select
          value={form.taxCategory}
          onChange={(event) =>
            onChange({ ...form, taxCategory: event.target.value as InvoiceTaxCategory })
          }
        >
          {invoiceTaxCategoryOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </FormField>

      <FormField label="Interne Notiz" hint="Nur intern sichtbar, nie auf der Rechnung.">
        <Textarea
          value={form.notes}
          onChange={(event) => onChange({ ...form, notes: event.target.value })}
          rows={2}
          maxLength={500}
        />
      </FormField>

      <label className="flex min-h-11 cursor-pointer items-center gap-3 pt-1">
        <input
          type="checkbox"
          checked={form.isActive}
          onChange={(event) => onChange({ ...form, isActive: event.target.checked })}
          className="accent-sage h-4 w-4"
        />
        <span className="text-ink text-sm">Beim Schreiben einer Rechnung anbieten</span>
      </label>
    </>
  );
}
